import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let component = () => import('@/views/index.vue')
if (/Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
    navigator.userAgent)) {
  component = () => import('@/views/indexH5.vue')
}

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: component
    },
    {
      path: '/download',
      name: 'DownLoad',
      component: () => import('@/views/download.vue')
    },
    {
      path: '/order',
      name: 'Order',
      component: () => import('@/views/order.vue'),
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/userInfo',
      name: 'UserInfo',
      component: () => import('@/views/userInfo.vue'),
      meta: {
        title: '客户资料'
      }
    },
    {
      path: '/grabOrder',
      name: 'GrabOrder',
      component: () => import('@/views/grabOrder.vue'),
      meta: {
        title: '用户分配'
      }
    },
    {
      path: '/userAllocation',
      name: 'UserAllocation',
      component: () => import('@/views/userAllocation.vue'),
      meta: {
        title: '用户分配'
      }
    },
    {
      path: '/API/CID',
      name: 'Document',
      component: () => import('@/views/document.vue'),
      meta: {
        title: '文档中心'
      }
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: () => import('@/views/agreement.vue'),
      meta: {
        title: '服务协议'
      }
    },
    {
      path: '/policy',
      name: 'Policy',
      component: () => import('@/views/policy.vue'),
      meta: {
        title: '隐私政策'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js